import { render, staticRenderFns } from "./ContentTabBody.vue?vue&type=template&id=145e67a7&scoped=true&"
import script from "./ContentTabBody.vue?vue&type=script&lang=js&"
export * from "./ContentTabBody.vue?vue&type=script&lang=js&"
import style0 from "./ContentTabBody.vue?vue&type=style&index=0&id=145e67a7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145e67a7",
  null
  
)

export default component.exports